"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCOPE = exports.TAG = exports.PARAMTYPE = void 0;
var PARAMTYPE;
(function (PARAMTYPE) {
    PARAMTYPE["Any"] = "any";
    PARAMTYPE["String"] = "string";
    PARAMTYPE["Numeric"] = "number";
    PARAMTYPE["NumberFormat"] = "number-format";
    PARAMTYPE["Boolean"] = "boolean";
    PARAMTYPE["Choice"] = "choice";
    PARAMTYPE["Date"] = "date";
    PARAMTYPE["DateTimeFormat"] = "date-time-format";
    PARAMTYPE["TimeZone"] = "timezone";
    PARAMTYPE["URL"] = "url";
    PARAMTYPE["List"] = "list";
    PARAMTYPE["ListItem"] = "list-item";
    PARAMTYPE["Color"] = "color";
})(PARAMTYPE || (exports.PARAMTYPE = PARAMTYPE = {}));
var TAG;
(function (TAG) {
    TAG["Function"] = "function";
    TAG["Formatter"] = "formatter";
    TAG["Operator"] = "operator";
})(TAG || (exports.TAG = TAG = {}));
var SCOPE;
(function (SCOPE) {
    SCOPE["Scene"] = "$scene";
})(SCOPE || (exports.SCOPE = SCOPE = {}));
//# sourceMappingURL=functionDefinitionTypes.js.map